import React, { ReactElement, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { GoChecklist } from 'react-icons/go';

import {
  RiArrowLeftRightFill,
  RiCalendarCheckLine,
  RiDatabase2Line,
  RiDeleteBin5Line,
  RiGuideLine,
  RiListOrdered,
  RiOrderPlayLine,
  RiPrinterLine,
  RiTruckFill,
  RiUserFollowLine,
} from 'react-icons/ri';
import { Container, CardContainer, Card } from './styles';

import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import ModalChegadaMotoristas from '../../components/ModalChegadaMotoristas';
import ModalCadastros from '../../components/ModalCadastros';
import ModalChangeDate from '../../components/Modals/ModalChangeDate';
import ModalDeleteProcess from '../../components/Modals/ModalDeleteProcess';
import ModalPrintQrCode from '../../components/Modals/ModalPrintQrCode';
import ModalTransportadoraProfile from '../../components/Modals/ModalTransportadoraProfile';
import ModalOrdemContingencia from '../../components/Modals/ModalOrdemContingencia';

import api from '../../services/api';
import ModalOrdemVendaSync from '../../components/Modals/ModalOrdemVendaSync';
import ModalTodoChecklist from '../../components/Modals/ModalTodoChecklist';
import ModalPrintChecklist from '../../components/Modals/ModalPrintChecklist';
import ModalOperationsReport from '../../components/Modals/ModalOperationsReport';

function PainelAdmin(): ReactElement {
  const { signOut, user } = useAuth();
  const { addToast } = useToast();
  const navigate = useNavigate();

  const [chegadaMotoristaModalOpen, setChegadaMotoristaModalOpen] =
    useState(false);

  const [cadastrosModalOpen, setCadastrosModalOpen] = useState(false);

  const [changeDateModalOpen, setChangeDateModalOpen] = useState(false);

  const [deleteProcessModalOpen, setDeleteProcessModalOpen] = useState(false);

  const [printQrCodeModalOpen, setPrintQrCodeModalOpen] = useState(false);

  const [transportadoraProfileModalOpen, setTransportadoraProfileModalOpen] =
    useState(false);

  const [ordemContingenciaModalOpen, setOrdemContingenciaModalOpen] =
    useState(false);

  const [ordemVendaSyncModalOpen, setOrdemVendaSyncModalOpen] = useState(false);

  const [todoChecklistModalOpen, setTodoChecklistModalOpen] = useState(false);

  const [filaCarregamento, setFilaCarregamento] = useState([]);
  const [ordensContingencia, setOrdensContingencia] = useState([]);

  const [printChecklistModalOpen, setPrintChecklistModalOpen] = useState(false);

  const [operationsReportModalOpen, setOperationsReportModalOpen] =
    useState(false);

  if (user.admin === false) {
    addToast({
      type: 'error',
      title: 'Acesso Restrito.',
      description: 'Disponível apenas para usuários Admin da Bom Sucesso.',
    });

    navigate('/portal');
  }

  // toggle modal Chegada Motorista,
  function toggleInsertChegadaMotorista(): void {
    setChegadaMotoristaModalOpen(!chegadaMotoristaModalOpen);
  }

  // toggle modal Cadastros
  function toggleCadastrosModal(): void {
    setCadastrosModalOpen(!cadastrosModalOpen);
  }

  // toggle modal ChangeDate
  function toggleChangeDateModal(): void {
    setChangeDateModalOpen(!changeDateModalOpen);
  }

  // toggle modal Delete Processo
  function toggleDeleteProcess(): void {
    setDeleteProcessModalOpen(!deleteProcessModalOpen);
  }

  // toggle modal print qr code
  function togglePrintQrCode(): void {
    setPrintQrCodeModalOpen(!printQrCodeModalOpen);
  }

  // toggle modal Transportadora Profile
  function toggleTransportadoraProfile(): void {
    setTransportadoraProfileModalOpen(!transportadoraProfileModalOpen);
  }

  // toggle modal Ordem Contingencia
  async function toggleOrdemContingencia(): Promise<void> {
    // Find ordem contingencia
    const foundOrdensContingencia = await api
      .get('/ordenscontingencia/')
      .then(response => {
        return response.data;
      });
    setOrdensContingencia(foundOrdensContingencia);
    setOrdemContingenciaModalOpen(!ordemContingenciaModalOpen);
  }

  function toggleOrdemVendaSync(): void {
    setOrdemVendaSyncModalOpen(!ordemVendaSyncModalOpen);
  }

  // toggle Todo Checklist Modal
  async function toggleTodoChecklist(): Promise<void> {
    // Find fila carregamento
    const foundFilaCarregamento = await api.get('/fila/').then(response => {
      const filteredFila = response.data.filter(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (fila: any) => fila.status === 'ACKL',
      );
      return filteredFila;
    });
    setFilaCarregamento(foundFilaCarregamento);
    setTodoChecklistModalOpen(!todoChecklistModalOpen);
  }

  function togglePrintChecklist(): void {
    setPrintChecklistModalOpen(!printChecklistModalOpen);
  }

  function toggleOperationsReport(): void {
    setOperationsReportModalOpen(!operationsReportModalOpen);
  }

  return (
    <Container>
      <ModalChegadaMotoristas
        isOpen={chegadaMotoristaModalOpen}
        setIsOpen={() => toggleInsertChegadaMotorista()}
      />

      <ModalCadastros
        isOpen={cadastrosModalOpen}
        setIsOpen={() => toggleCadastrosModal()}
      />

      <ModalChangeDate
        isOpen={changeDateModalOpen}
        setIsOpen={() => toggleChangeDateModal()}
      />

      <ModalDeleteProcess
        isOpen={deleteProcessModalOpen}
        setIsOpen={() => toggleDeleteProcess()}
      />

      <ModalPrintQrCode
        isOpen={printQrCodeModalOpen}
        setIsOpen={() => togglePrintQrCode()}
      />

      <ModalTransportadoraProfile
        isOpen={transportadoraProfileModalOpen}
        setIsOpen={() => toggleTransportadoraProfile()}
      />

      <ModalOrdemContingencia
        isOpen={ordemContingenciaModalOpen}
        setIsOpen={() => toggleOrdemContingencia()}
        ordensData={ordensContingencia}
      />

      <ModalOrdemVendaSync
        isOpen={ordemVendaSyncModalOpen}
        setIsOpen={() => toggleOrdemVendaSync()}
      />

      <ModalTodoChecklist
        isOpen={todoChecklistModalOpen}
        setIsOpen={() => toggleTodoChecklist()}
        filaData={filaCarregamento}
      />

      <ModalPrintChecklist
        isOpen={printChecklistModalOpen}
        setIsOpen={() => togglePrintChecklist()}
      />

      <ModalOperationsReport
        isOpen={operationsReportModalOpen}
        setIsOpen={() => toggleOperationsReport()}
      />

      <header>
        <h1>Bom Sucesso Agroindústria S.A</h1>

        <nav>
          <button type="submit" onClick={() => navigate('/')}>
            Página Inicial
          </button>

          <button type="submit" onClick={() => navigate('/admin')}>
            Voltar
          </button>

          <button type="submit" onClick={signOut}>
            Logout
          </button>
        </nav>
      </header>
      <h2 id="pageTitle">Painel Admin</h2>

      <h2 id="selectOption">Selecione uma opção</h2>

      <CardContainer>
        {/* Admin Card - only accessible to user.admin */}

        {/* Cadastros */}
        <Card onClick={() => toggleCadastrosModal()}>
          <h1 className="cadastros" id="cadastros" data-testid="cadastros">
            Cadastros
          </h1>
          <RiDatabase2Line size={42} color="#fff" />
        </Card>

        {/* Confirmar Motorista */}
        <Card onClick={() => toggleInsertChegadaMotorista()}>
          <h1
            className="cadConfirmaMotorista"
            id="cadConfirmaMotorista"
            data-testid="cadConfirmaMotorista"
          >
            Confirmar Motorista
          </h1>
          <RiUserFollowLine size={42} color="#fff" />
        </Card>

        {/* Vinculo Pedido Transportadora */}
        <Card onClick={() => navigate('/vinculopedidos')}>
          <h1
            className="vinculopedido"
            id="cadVinculoPedido"
            data-testid="vinculopedido"
          >
            Vinculo Pedido/F.A
          </h1>
          <RiOrderPlayLine size={42} color="#fff" />
        </Card>

        {/* Mudar Data Processo Carregamento */}
        <Card onClick={() => toggleChangeDateModal()}>
          <h1 className="changeDate" id="changeDate" data-testid="changeDate">
            Alterar Data
          </h1>
          <RiCalendarCheckLine size={42} color="#fff" />
        </Card>

        {/* DeletarProcesso Carregamento */}
        <Card onClick={() => toggleDeleteProcess()}>
          <h1
            className="deleteprocess"
            id="deleteprocess"
            data-testid="deleteprocess"
          >
            Excluir Processo
          </h1>
          <RiDeleteBin5Line size={42} color="#fff" />
        </Card>

        {/* Reimpressão de QrCode Checklist */}
        <Card onClick={() => togglePrintQrCode()}>
          <h1
            className="printQrCode"
            id="printQrCode"
            data-testid="printQrCode"
          >
            Impressão QRCode
          </h1>
          <RiPrinterLine size={42} color="#fff" />
        </Card>

        {/* Update dados transportadora */}
        <Card onClick={() => toggleTransportadoraProfile()}>
          <h1
            className="transportadoraProfile"
            id="transportadoraProfile"
            data-testid="transportadoraProfile"
          >
            Transportadora Profile
          </h1>
          <RiTruckFill size={42} color="#fff" />
        </Card>

        {/* Ordem Contingencia */}
        <Card onClick={() => toggleOrdemContingencia()}>
          <h1
            className="ordemContingencia"
            id="ordemContingencia"
            data-testid="ordemContingencia"
          >
            Ordem Contingencia
          </h1>
          <RiGuideLine size={42} color="#fff" />
        </Card>

        {/* Ordem Venda */}
        <Card onClick={() => toggleOrdemVendaSync()}>
          <h1
            className="ordemVendaSync"
            id="ordemVendaSync"
            data-testid="ordemVendaSync"
          >
            Sinc. Fat. SAP
          </h1>
          <RiArrowLeftRightFill size={42} color="#fff" />
        </Card>

        {/* Checklist */}
        <Card onClick={() => toggleTodoChecklist()}>
          <h1 className="checklist" id="checklist" data-testid="checklist">
            Checklist
          </h1>
          <GoChecklist size={42} color="#fff" />
        </Card>

        {/* Print Checklist */}
        <Card onClick={() => togglePrintChecklist()}>
          <h1
            className="print-checklist"
            id="print-checklist"
            data-testid="print-checklist"
          >
            Impressão Checklist
          </h1>
          <RiPrinterLine size={42} color="#fff" />
        </Card>

        {/* Operations Report */}
        <Card onClick={() => toggleOperationsReport()}>
          <h1
            className="operations-report"
            id="operations-report"
            data-testid="operations-report"
          >
            Relatório Operação
          </h1>
          <RiListOrdered size={42} color="#fff" />
        </Card>
      </CardContainer>
    </Container>
  );
}

export default PainelAdmin;
